import type { RequestStatus } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests.types'
import type {
  GetRequestsParams,
  OrderBy,
} from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/requests/requests'

export const MISSIONS_PAGE_SIZE = 20

export const getRequestsParams = (
  status: RequestStatus | null,
  orderBy: OrderBy,
  isAddYourOwnMission?: boolean,
  page?: number,
  isGroupMission?: boolean,
): GetRequestsParams => ({
  order_by: orderBy,
  page: page ?? 1,
  size: MISSIONS_PAGE_SIZE,
  ...(status === 'APPROVED' || status === 'REJECTED' ? { approved: status === 'APPROVED' } : {}),
  ...(status === 'PENDING' ? { approved__isnull: true as true } : {}),
  ...(isAddYourOwnMission
    ? { single_volunteer_enrol_permission_assignment: isAddYourOwnMission }
    : {}),
  ...(isGroupMission ? { is_group_mission: true } : {}),
})
